import {useLocation} from '@reach/router';

// Separate the redirect logic of BRS flow
const useIsRedirectFromBRS = (): boolean => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isContainsApplicationId = searchParams.get('r');
  const isContainApplicationReference = searchParams.get('application_reference');

  if (isContainApplicationReference && isContainsApplicationId) {
    return true;
  }
  return false;
};

export default useIsRedirectFromBRS;
